import angular from 'angular';
import { devLoggingService } from './dev-logger.service';
angular
  .module('flowingly.components')
  .factory('devLoggingService', devLoggingService);
